"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2026],{

/***/ 45916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ AfterpayInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20368);
/* harmony import */ var ui_components_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51377);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79758);
/* harmony import */ var ui_components_ManagedHeading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93512);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6485);








var AfterpayInfo = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setOpen = ref[1];
    var country = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__/* .useSiteConfig */ .N)().country;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: function() {
                    return setOpen(true);
                },
                className: "h-[24px] px-1.5 py-[9px] border-2 hover:(border-[#8C9198] border-2) border border-[#DFE0E1] rounded-sm flex items-center mx-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO$, {
                    name: "payment-afterpay-inline",
                    label: "Learn more about Afterpay",
                    className: "h-[24px]! w-[40px]!"
                })
            }),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                variant: "dark",
                onClickOutside: function() {
                    setOpen(false);
                },
                className: "max-w-md py-8 xs:px-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: "absolute top-5 right-5 !mt-0",
                        onClick: function() {
                            setOpen(false);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "space-y-6 text-center flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "bg-[#88fce3] px-2 py-1 rounded-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO$, {
                                    name: "payment-afterpay",
                                    size: "10xl",
                                    aspectRatio: 0.6
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_ManagedHeading__WEBPACK_IMPORTED_MODULE_6__/* .ManagedHeading */ .P, {
                                className: "font-bold text-3xl",
                                tag: "h1",
                                children: [
                                    "Shop Now, Pay Later.",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    "Always interest-free."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "px-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        "aria-hidden": true,
                                        src: "/assets/afterpay-instructions.png",
                                        alt: "",
                                        width: "655",
                                        height: "609"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "sr-only",
                                        children: "Add your favorites to cart. "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "sr-only",
                                        children: "Select Afterpay at checkout. "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "sr-only",
                                        children: "Log into or create your Afterpay account, with instant approval decision."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "sr-only",
                                        children: "Your purchase will be split into 4 payments, payable every 2 week"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    country === utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .SUPPORTED_COUNTRY.US */ .bM.US && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-xs mb-6",
                                                children: [
                                                    "You must be over 18, a resident of the U.S. and meet additional eligibility criteria to qualify. Late fees apply. Estimated payment amounts shown on product pages exclude taxes and shipping charges, which are added at checkout.",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        target: "_blank",
                                                        referrerPolicy: "no-referrer",
                                                        href: "https://www.afterpay.com/installment-agreement",
                                                        className: "underline",
                                                        rel: "noreferrer",
                                                        children: [
                                                            " ",
                                                            "Click here for complete terms."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-xs opacity-60",
                                                children: "Loans to California residents made or arranged pursuant to a California Finance Lenders Law license."
                                            })
                                        ]
                                    }),
                                    country === utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .SUPPORTED_COUNTRY.CA */ .bM.CA && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-xs",
                                                children: [
                                                    "You must be of the age of majority in your province or territory, a resident of Canada, and meet additional eligibility criteria to qualify. See",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        target: "_blank",
                                                        referrerPolicy: "no-referrer",
                                                        href: "https://www.afterpay.com/en-ca",
                                                        rel: "noreferrer",
                                                        children: "http://afterpay.com/en-ca"
                                                    }),
                                                    " ",
                                                    "for more details."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-xs",
                                                children: "\xa9 2020 Afterpay Canada"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 72026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ AfterpayOrKlarnaText; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/usePriceFormatter.ts + 1 modules
var usePriceFormatter = __webpack_require__(23658);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./ui/components/AfterpayInfo.tsx
var AfterpayInfo = __webpack_require__(45916);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
;// CONCATENATED MODULE: ./ui/components/KlarnaInfo.tsx




var KlarnaInfo = function() {
    var showDisclaimerMessage = (0,useFeature/* useFeature */.S)("SHOW_KLARNA_DISCLAIMER_MESSAGE");
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var steps = [
        {
            text: "At checkout select Klarna"
        },
        {
            text: "Choose your payment plan",
            description: "Different payment plans may be shown depending on the purchase amount and credit score. "
        },
        {
            text: "Complete your checkout",
            description: "The amount will be charged based on the payment plan you choose."
        }, 
    ];
    // Adjusts the top property of the uds close button inside
    // the DialogHeader to align it with Klarna Icon
    (0,react.useEffect)(function() {
        if (isOpen) {
            var svgIcon = document.querySelector('[data-uds-child="dialog-header"] button[data-uds-child="button-icon"]');
            if (svgIcon) {
                svgIcon.classList.add("top-7");
            }
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DialogRoot */.GRm, {
        drawer: false,
        onOpenChange: function() {
            return setIsOpen(!isOpen);
        },
        align: {
            xs: "center"
        },
        justify: {
            xs: "center"
        },
        size: {
            xs: "xs"
        },
        dataTestId: "klarna-modal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogTrigger */.hgM, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "h-[24px] px-1 py-[9px] hover:(border-[#8C9198] border-2) border-2 border border-[#DFE0E1] rounded-sm flex items-center mx-1",
                    "data-test-id": "klarna-button-id",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                        name: "payment-klarna",
                        className: "h-[24px]! w-[40px]!",
                        "data-test-id": "klarna-button-icon-id",
                        label: "klarna-payment-info"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DialogContent */.cZJ, {
                className: "fixed bottom-0 right-0 xs:(relative bottom-auto right-auto) w-full pt-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogHeader */.fKu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogHeading */.EtB, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                name: "payment-klarna-inline",
                                size: "9xl",
                                aspectRatio: 0.5,
                                "data-test-id": "klarna-icon-id"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogBody */.a7O, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                            direction: "column",
                            gapY: "lg",
                            className: "pb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                    gapY: "none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                                            weight: "bold",
                                            size: "xl",
                                            children: "Buy Now. Pay with Klarna"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                                            size: "base",
                                            children: "Get what you love, choose how to pay."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                    gapY: "none",
                                    className: "bg-neutral-10 px-[46px] pt-4 py-6 rounded",
                                    "data-test-id": "klarna-how-it-works-id",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                                            weight: "bold",
                                            size: "lg",
                                            className: "mb-2.5",
                                            children: "How it Works"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "flex flex-col gap-y-6 relative",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute top-1 left-[3px] h-40 w-0.5 bg-neutral-60 z-0"
                                                }),
                                                steps.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        className: "flex items-start gap-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "z-10 bg-neutral-10 py-3",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    width: "8",
                                                                    height: "8",
                                                                    viewBox: "0 0 8 8",
                                                                    fill: "none",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                                        cx: "4",
                                                                        cy: "4",
                                                                        r: "4",
                                                                        fill: "#676D75"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                                                direction: "column",
                                                                gapY: "none",
                                                                className: "my-[3px]",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                                                                        size: "base",
                                                                        className: "text-neutral-60",
                                                                        children: item.text
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                                                                        size: "xs",
                                                                        className: "text-neutral-60 text-balance",
                                                                        children: item.description
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                showDisclaimerMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Text */.xvT, {
                                    size: "xxs",
                                    className: "text-neutral-60",
                                    "data-test-id": "klarna-terms-id",
                                    children: [
                                        "*See payment",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/sliceitinx#2",
                                            target: "_blank",
                                            className: "underline underline-offset-[2px]",
                                            rel: "noreferrer",
                                            children: "terms"
                                        }),
                                        ". A higher initial payment may be required for some consumers. CA resident loans made or arranged pursuant to a California Financing Law license."
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DialogFooter */.cNS, {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogTrigger */.hgM, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ButtonCta */.NlM, {
                                    label: "Close",
                                    "data-test-id": "close-button-id"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LinkCta */.NIR, {
                                label: "Learn more",
                                variant: "secondary",
                                href: "/help/klarna"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/AfterpayOrKlarnaText.tsx











var AfterpayOrKlarnaText = function(props) {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var formatter = (0,usePriceFormatter/* usePriceFormatter */.o)();
    var isAfterPayEnabled = (0,useFeature/* useFeature */.S)(constants/* PaymentMethod.AFTERPAY */.XL.AFTERPAY);
    var isKlarnaEnabled = (0,useFeature/* useFeature */.S)("KLARNA_ENABLED");
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useAfterPayConfigQuery */.vkA)({
        pause: constants/* isServer */.sk || !isAfterPayEnabled
    }), 1), afterPayConfig = ref1[0];
    if (!props.amount || !isAfterPayEnabled || !((ref = afterPayConfig.data) === null || ref === void 0 ? void 0 : ref.afterPayConfig)) return null;
    var afterpayText = t("afterpayText");
    var amountText = formatter(props.amount / 4);
    var textMatchWithComponent = {
        "{amount}": amountText,
        "{AfterPayInfo}": /*#__PURE__*/ (0,jsx_runtime.jsx)(AfterpayInfo/* AfterpayInfo */.q, {})
    };
    var afterpayWithAmountText = afterpayText.split(/({\w+})/).map(function(text) {
        return textMatchWithComponent[text] || text;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center items-center flex-row! text-xs",
        children: props.amount < afterPayConfig.data.afterPayConfig.min || props.amount > afterPayConfig.data.afterPayConfig.max ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            "data-test-id": "afterpay-price-boundaries",
            children: t("afterPayBoundariesCartSummary", {
                currency: currency.symbol,
                min: afterPayConfig.data.afterPayConfig.min,
                max: afterPayConfig.data.afterPayConfig.max
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            "data-test-id": "afterpay-price-breakdown",
            className: "flex justify-center items-center flex-row!",
            children: [
                afterpayWithAmountText.map(function(segment, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: segment
                    }, index);
                }),
                isKlarnaEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        "or ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(KlarnaInfo, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: "Afterpay"
                })
            ]
        })
    });
};


/***/ })

}]);